// After a deploy, a tab opened before it still runs the old main bundle, which
// asks for lazy chunks by their old hashed names. Those files are gone, so the
// import fails with a ChunkLoadError. Reloading picks up the new build. The
// time of the last reload is kept in session storage so a chunk that is still
// missing afterwards fails normally instead of reloading forever.

const RELOAD_STORAGE_KEY = 'staleChunkReloadAt';
const RELOAD_COOLDOWN_MS = 60 * 1000;

function claimReload(getStorage, time) {
	try {
		const storage = getStorage();
		const lastReloadAt = Number(storage.getItem(RELOAD_STORAGE_KEY));
		if(lastReloadAt && time - lastReloadAt < RELOAD_COOLDOWN_MS) {
			return false;
		}
		storage.setItem(RELOAD_STORAGE_KEY, String(time));
		return true;
	} catch(error) {
		return false;
	}
}

// Wraps webpack's chunk loader (`__webpack_require__.e`), which every import()
// in the bundle goes through.
export function guardChunkLoading(runtime, { getStorage, reload, now = Date.now }) {
	const loadChunk = runtime.e;
	if(typeof loadChunk !== 'function') {
		return;
	}
	runtime.e = (chunkId) => loadChunk(chunkId).catch((error) => {
		if(error?.name !== 'ChunkLoadError' || !claimReload(getStorage, now())) {
			throw error;
		}
		reload();
		return new Promise(() => {});
	});
}
